import { AuthBase } from "../../auth";
import { IdentityAuth } from "../../../utils/interfaces/auth/imp/auth-identity";

class _AuthController extends AuthBase {
    constructor() {
        super({
            modules: {
                auth: new IdentityAuth()
            }
        });
    }
}

export const AuthController = new _AuthController();